/** 侧栏从其它页点「自媒体助手」时置位;MediaEditorView 挂载时消费一次。 */
let pending = false

export function armMediaFlowHint() {
  pending = true
}

export function takeMediaFlowHint(): boolean {
  const v = pending
  pending = false
  return v
}
